import { css } from 'styled-components'

const transparentLightButtonTemplate = () => css`
  background: transparent;
  color: var(--sl-color-gray-1);

  min-width: unset;
  height: auto;
  padding: 0.125rem 0.25rem;

  &:not(:disabled) {
    &:hover {
      color: var(--sl-fg-inverted);
    }
  }
`

export default transparentLightButtonTemplate
